import React from "react";
import { useFormContext } from "react-hook-form";
import { FormControlLabel, RadioGroup } from "@mui/material";
import Radio from "@mui/material/Radio";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import { IRadioGroup } from "./ExlyRadioGroup.interfaces";

const ExlyRadioGroup = (props: IRadioGroup) => {
    const {
        name,
        classes,
        options = [],
        registerOptions,
        CustomErrorMessageComponent,
        labelProps = {},
        radioProps = {},
        onChange,
    } = props;

    const {
        getValues,
        register,
        formState: { errors },
    } = useFormContext();
    const data = getValues();

    // considering "" (empty string) is not added as an option
    const preFilledValue = name ? data?.[name] : "";
    const error = name ? errors[name] : null;
    const showError = !!error;
    const { message: errorMessage } = error || {};

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange((event.target as HTMLInputElement).value);
    };
    return (
        <div>
            <RadioGroup
                onChange={handleRadioChange}
                className={classes?.optionsStyle}
            >
                {options.map((option, idx) => (
                    <FormControlLabel
                        value={option}
                        label={option}
                        // Creator might make 2 options with same values.
                        // Rare but possible.
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${option}-${idx}`}
                        control={
                            <Radio
                                {...radioProps}
                                checked={option === preFilledValue}
                            />
                        }
                        {...(name ? register(name, registerOptions) : {})}
                        {...labelProps}
                    />
                ))}
            </RadioGroup>
            <ErrorMessage
                showError={showError}
                classes={classes}
                CustomErrorMessageComponent={CustomErrorMessageComponent}
                errorMessage={errorMessage}
            />
        </div>
    );
};

ExlyRadioGroup.defaultProps = {
    labelProps: {},
    radioProps: {},
};

export default ExlyRadioGroup;
